import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

//---- Components
import { HeaderComponent } from '../../shared/components/header/header.component';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';
@Component({
    selector: 'app-front-layout',
    templateUrl: './front-layout.component.html',
    styleUrls: ['./front-layout.component.scss'],
    imports: [RouterOutlet, HeaderComponent, SidebarComponent]
})
export class FrontLayoutComponent {

  sidebarOpen = false;

  openSidebar() {
    this.sidebarOpen = true;
  }
  closeSidebar() {
    this.sidebarOpen = false;
  }

}
